module.exports = __webpack_public_path__ + "images/img-2zW6BUS.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/managers/61.jpg
// module id = 2012
// module chunks = 0